import { FulfillmentOrderAddressSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { OutboundParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createReturnLabel = {
  name: "createReturnLabel" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shopperAddress: FulfillmentOrderAddressSchema,
    merchantAddress: FulfillmentOrderAddressSchema,
    parcel: OutboundParcelSchema,
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
